export const demoCanvasConfig = {
    nodes: [
        {
            id: '6tr378oCZOCx8AY9JOvuz',
            type: 'upload',
            position: { x: -400, y: 650 },
            data: {
                name: 'Image Upload',
                fileType: 'image',
                content: {
                    url: 'https://flowmuse-public.oss-ap-northeast-1.aliyuncs.com/public/upload.webp',
                    type: 'image/jpeg',
                    name: 'upload.webp',
                },
                size: '2800x1385',
                width: 384,
                height: 190,
            },
            origin: [0, 0.5] as [number, number],
        },
        {
            id: '-b1VXJsrpFGy3xa6ZpF0b',
            type: 'image',
            position: { x: 650, y: 250 },
            data: {
                name: 'First Frame',
                model: 'nano-banana-2',
                size: '16x9',
                generated: {
                    url: 'https://flowmuse-public.oss-ap-northeast-1.aliyuncs.com/public/first.webp',
                    type: 'image/png',
                },
                instructions: 'The image shows the planetary engine from The Wandering Earth. Draw the ever-changing environment of outer space.',
                style: "custom",
                width: 384,
                height: 216,
                status: 'completed',
            },
            origin: [0, 0.5] as [number, number],
        },
        {
            id: 'XPJCSlrAQ_uqWRTfrsg9X',
            type: 'image',
            position: { x: 650, y: 1050 },
            data: {
                name: 'Last Frame',
                model: 'nano-banana-2',
                size: '16x9',
                instructions: 'The image shows the planetary engine from The Wandering Earth. Draw the scene where the engine flames rise higher.',
                style: "custom",
                generated: {
                    url: 'https://flowmuse-public.oss-ap-northeast-1.aliyuncs.com/public/last.webp',
                    type: 'image/png',
                },
                width: 384,
                height: 216,
                status: 'completed',
            },
            origin: [0, 0.5] as [number, number],
        },
        {
            id: '0dX_zas1bcso1GOZ_8UcP',
            type: 'video',
            position: { x: 1700, y: 650 },
            data: {
                name: 'Video Node 1',
                aspectRatio: 'match',
                duration: 6,
                quality: '720p',
                instructions: 'During the journey of The Wandering Earth, danger strikes and the engine power is boosted.',
                style: "custom",
                model: 'seedance-2.0',
                frameMode: 'first_last',
                generated: {
                    url: 'https://flowmuse-public.oss-ap-northeast-1.aliyuncs.com/public/vidu.webm',
                    type: 'video/mp4',
                },
                width: 384,
                height: 216,
                status: 'completed',
            },
            origin: [0, 0.5] as [number, number],
        },
    ],
    edges: [
        { id: '8Zl9O2dPQv53g_LR5hiS0', source: '6tr378oCZOCx8AY9JOvuz', target: '-b1VXJsrpFGy3xa6ZpF0b', type: 'animated' },
        { id: 'HOV6_VFCC7VYZP2YHqL2-', source: '6tr378oCZOCx8AY9JOvuz', target: 'XPJCSlrAQ_uqWRTfrsg9X', type: 'animated' },
        { id: 'sRj5yabgAfK1nOuoCInTK', source: '-b1VXJsrpFGy3xa6ZpF0b', target: '0dX_zas1bcso1GOZ_8UcP', type: 'animated', data: { frameRole: 'start' } },
        { id: 'onzIofn_TFgYS2scnwdjR', source: 'XPJCSlrAQ_uqWRTfrsg9X', target: '0dX_zas1bcso1GOZ_8UcP', type: 'animated', data: { frameRole: 'end' } },
    ],
    textOverlays: [],
    shapeOverlays: [],
};


